import styles from '../../index.module.scss';
import type { MappingRuleChat } from '../useMappingRuleChat';

// Replaces the details card once the drawer has been opened, so the thread
// records what happened instead of leaving a form the user has moved on from.
export default function HandedOffCard({ chat }: { chat: MappingRuleChat }) {
	const { mode, details } = chat;
	return (
		<div className={styles['action-card']}>
			{mode === 'edit'
				? '✓ Opened that rule in Settings → Configurations.'
				: `✓ Opened the rule builder in Settings → Configurations${
					details.name ? ` for “${details.name}”` : ''
				}. Finish the criteria and account mapping there, then Save.`}
		</div>
	);
}
